var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckWithCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.032 3.697A11.965 11.965 0 0 0 12.379.01c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.626 0 12-5.373 12-12 0-2.673-.875-5.142-2.353-7.136l2.352-2.283-1.094-1.081-2.252 2.187ZM19.915 4.78a10.42 10.42 0 0 0-7.536-3.219C6.614 1.562 1.93 6.245 1.93 12.01c0 5.764 4.683 10.448 10.448 10.448 5.764 0 10.447-4.683 10.447-10.448 0-2.25-.714-4.335-1.928-6.041l-9.315 9.041-5.205-5.02 1.094-1.08 4.111 3.958 8.332-8.087Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckWithCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckWithCircle.2ac80667536593ef8aeaed0df6ac234a.svg";